module.exports = __webpack_public_path__ + "media/images/testimonials/telenor-c554bfbe1309587fb402229cc16cc8a2.png";